
import { useContext, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@headlessui/react";

import slide1 from "../../assets/carousel1.avif";
import slide2 from "../../assets/carousel2.avif";
import slide3 from "../../assets/carousel3.avif";
import slide4 from "../../assets/carousel4.avif";
import slide5 from "../../assets/carousel5.avif";
import { DContext } from "../../context/DataContext";
import { useNavigate } from "react-router-dom";

export default function Explore() {
    const [active, setActive] = useState(0);
    const { setOpenForm } = useContext(DContext)
    const totalSlides = 5;

    const navigate = useNavigate()

    // Auto-play like video
    useEffect(() => {
        const timeout = setTimeout(() => {
            setActive((prev) => (prev + 1) % totalSlides);
        }, 3500);

        return () => clearTimeout(timeout);
    }, [active]);

    return (

        <section className="md:py-2  sm:px-6 md:px-12 lg:px-24 sm:my-6 ">
            <div className="relative overflow-hidden sm:mx-auto md:max-w-7xl">

                {/* HEIGHT HOLDER */}
                <div className="  relative w-full flex justify-center  min-h-[600px] md:min-h-[520px] lg:min-h-[700px] ">
                    <AnimatePresence initial={false}>
                        <motion.div
                            key={active}
                            className="absolute inset-0 flex justify-center"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.9, ease: 'easeInOut' }}
                        >

                            {/* ===== SLIDE 1 ===== */}
                            {active === 0 && (
                                <div className="relative w-full flex justify-center ">
                                    <img
                                        src={slide1}
                                        alt=""
                                        className="w-full h-[650px] md:h-auto object-cover max-w-[1260px]"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />

                                    <div className="  absolute bottom-8 md:top-[30%] lg:top-[15%] left-4 md:left-8 lg:left-[10%] right-4 ">
                                        <div className="bg-white/50 lg:bg-transparent h-[235px] md:h-0 md:max-w-[700px] lg:max-w-[842px]  px-3 py-2 md:p-3  rounded-2xl">
                                            <h1 className="pt-3 font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl  max-w-full md:max-w-[700px] lg:max-w-[842px]
                    leading-tight lg:leading-[70px] ">
                                                Engineering Intelligence Into Digital Experiences
                                            </h1>

                                            <p className=" font-medium text-white font-secondary text-sm sm:text-base md:text-lg lg:text-2xl
                    max-w-full md:max-w-[700px] lg:max-w-[842px] py-2 lg:py-3 "
                                            >
                                                We design enterprise technology solutions combining intelligence,
                                                engineering precision, and long-term business value.
                                            </p>

                                            <div className="flex  sm:flex-row gap-3 sm:gap-4 mt-4">
                                                <button
                                                    onClick={() => navigate('/capable')}
                                                    className=" hidden sm:flex w-[250px] sm:w-fit  text-secondary-500 font-semibold sm:text-base py-2.5 px-6
                      bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition text-sm">
                                                    Explore Our Capabilities
                                                </button>

                                                <Button className=" w-[100px] sm:w-[120px] h-[42px] text-white
                      bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                                    onClick={() => setOpenForm(true)}
                                                >
                                                    Let's Talk
                                                </Button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}

                            {/* ===== SLIDE 2 ===== */}
                            {active === 1 && (
                                <div className="relative w-full flex justify-center">
                                    <img
                                        src={slide2}
                                        alt=""
                                        className="w-full h-[650px] md:h-auto object-cover max-w-[1260px]"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />

                                    <div className="  absolute bottom-8 md:top-[30%] lg:top-[15%] left-4 md:left-8 lg:left-[10%] right-4 ">
                                        <div className="bg-white/50 lg:bg-transparent h-[235px] md:h-0 md:max-w-[700px] lg:max-w-[842px]  px-3 py-2 md:p-3 lg:p-5 rounded-2xl">
                                            <h1 className="pt-3 font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl  max-w-full md:max-w-[700px] lg:max-w-[842px]
                    leading-tight lg:leading-[70px] ">
                                                Intelligence Embedded Across Enterprise Systems
                                            </h1>

                                            <p className=" font-medium text-white font-secondary text-sm sm:text-base md:text-lg lg:text-2xl
                    max-w-full md:max-w-[700px] lg:max-w-[842px] py-2 lg:py-3 "
                                            >
                                                We build AI-driven platforms that analyze, adapt, and enable
                                                smarter operational decision-making.
                                            </p>

                                            <div className="flex  sm:flex-row gap-3 sm:gap-4 mt-4">
                                                <button
                                                    onClick={() => navigate('/capable')}
                                                    className=" hidden sm:flex w-[250px] sm:w-fit  text-secondary-500 font-semibold sm:text-base py-2.5 px-6
                      bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition text-sm">
                                                    Explore Our Capabilities
                                                </button>

                                                <Button className=" w-[100px] sm:w-[120px] h-[42px] text-white
                      bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                                    onClick={() => setOpenForm(true)}
                                                >
                                                    Let's Talk
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}

                            {/* ===== SLIDE 3 ===== */}
                            {active === 2 && (
                                <div className="relative w-full flex justify-center">
                                    <img
                                        src={slide3}
                                        alt=""
                                        className="w-full h-[650px] md:h-auto object-cover max-w-[1260px]"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />

                                    <div className="  absolute bottom-8 md:top-[30%] lg:top-[15%] left-4 md:left-8 lg:left-[10%] right-4 ">
                                        <div className="bg-white/50 lg:bg-transparent md:max-w-[700px] h-[235px] md:h-0 lg:max-w-[842px] px-3 py-2 md:p-3 lg:p-5 rounded-2xl">
                                            <h1 className="pt-3 font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl  max-w-full md:max-w-[700px] lg:max-w-[842px]
                    leading-tight lg:leading-[70px] ">
                                                Scalable Products Built For Modern Enterprises
                                            </h1>

                                            <p className=" font-medium text-white font-secondary text-sm sm:text-base md:text-lg lg:text-2xl
                    max-w-full md:max-w-[700px] lg:max-w-[842px] py-2 lg:py-3 "
                                            >
                                                Our platforms are engineered for performance, security, scalability, and real-world business environments.
                                            </p>

                                            <div className="flex  sm:flex-row gap-3 sm:gap-4 my-4">
                                                <button
                                                    onClick={() => navigate('/capable')}
                                                    className=" hidden sm:flex w-[250px] sm:w-fit  text-secondary-500 font-semibold sm:text-base py-2.5 px-6
                      bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition text-sm">
                                                    Explore Our Capabilities
                                                </button>

                                                <Button className=" w-[100px] sm:w-[120px] h-[42px] text-white
                      bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                                    onClick={() => setOpenForm(true)}                          >
                                                    Let's Talk
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ===== SLIDE 4 ===== */}
                            {active === 3 && (
                                <div className="relative w-full flex justify-center">
                                    <img
                                        src={slide4}
                                        alt=""
                                        className="w-full h-[650px] md:h-auto object-cover max-w-[1260px]"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />

                                    <div className="  absolute bottom-8 md:top-[30%] lg:top-[15%] left-4 md:left-8 lg:left-[10%] right-4 ">
                                        <div className="bg-white/50 lg:bg-transparent h-[250px] md:h-0 md:max-w-[700px] lg:max-w-[842px]  px-3 py-2 md:p-3 lg:p-5 rounded-2xl">
                                            <h1 className="pt-3  font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl  max-w-full md:max-w-[700px] lg:max-w-[842px]
                    leading-tight lg:leading-[70px] ">
                                                Unified Systems For Modern Business Operations
                                            </h1>

                                            <p className=" font-medium text-white font-secondary text-sm sm:text-base md:text-lg lg:text-2xl
                    max-w-full md:max-w-[700px] lg:max-w-[842px] py-2 lg:py-3 "
                                            >
                                                We bring together software, platforms, and connected technologies into cohesive digital ecosystems.
                                            </p>

                                            <div className="flex  sm:flex-row gap-3 sm:gap-4 my-4">
                                                <button
                                                    onClick={() => navigate('/capable')}
                                                    className=" hidden sm:flex w-[250px] sm:w-fit  text-secondary-500 font-semibold sm:text-base py-2.5 px-6
                      bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition text-sm">
                                                    Explore Our Capabilities
                                                </button>

                                                <Button className=" w-[100px] sm:w-[120px] h-[42px] text-white
                      bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                                    onClick={() => setOpenForm(true)}
                                                >
                                                    Let's Talk
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ===== SLIDE 5 ===== */}
                            {active === 4 && (
                                <div className="relative w-full flex justify-center">
                                    <img
                                        src={slide5}
                                        alt=""
                                        className="w-full h-[650px] md:h-auto object-cover max-w-[1260px]"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />

                                    <div className="  absolute bottom-8 md:top-[30%] lg:top-[15%] left-4 md:left-8 lg:left-[10%] right-4 ">
                                        <div className="bg-white/50 lg:bg-transparent h-[250px] md:h-0 md:max-w-[700px] lg:max-w-[842px]  px-3 py-2 md:p-3 lg:p-5 rounded-2xl">
                                            <h1 className=" pt-3 font-bold text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl  max-w-full md:max-w-[700px] lg:max-w-[842px]
                    leading-tight lg:leading-[70px] ">
                                                Technology Built With Purpose And Trust
                                            </h1>

                                            <p className=" font-medium text-white font-secondary text-sm sm:text-base md:text-lg lg:text-2xl
                    max-w-full md:max-w-[700px] lg:max-w-[842px] py-2 lg:py-3 "
                                            >
                                                We work as long-term partners delivering reliable solutions aligned with business goals and users.
                                            </p>

                                            <div className="flex  sm:flex-row gap-3 sm:gap-4 my-4">
                                                <button
                                                    onClick={() => navigate('/capable')}
                                                    className=" hidden sm:flex w-[250px] sm:w-fit  text-secondary-500 font-semibold sm:text-base py-2.5 px-6
                      bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition text-sm">
                                                    Explore Our Capabilities
                                                </button>

                                                <Button className=" w-[100px] sm:w-[120px] h-[42px] text-white
                      bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                                    onClick={() => setOpenForm(true)}
                                                >
                                                    Let's Talk
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </motion.div>
                    </AnimatePresence>
                </div>

                {/* DOTS */}
                <div
                    className=" absolute  bottom-3 md:bottom-12 lg:bottom-[20%] flex gap-3 z-10 md:right-9 right-1/3">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <button
                            key={i}
                            onClick={() => setActive(i)}
                            className={`h-3 rounded-full transition-all duration-500 ${active === i ? 'w-10 bg-secondary-500' : 'w-[6px] bg-white'
                                }`}
                        />
                    ))}
                </div>

            </div>
        </section >


    );
}


